(() => {
  function initializePrivacyComparisons(scope = document) {
    scope.querySelectorAll('[data-cm-privacy-comparison]').forEach(root => {
      if (root.dataset.comparisonInitialized) return;
      root.dataset.comparisonInitialized = 'true';
      const base = root.querySelector('img'), nextLayer = root.querySelector('.cm-privacy-next');
      const next = nextLayer.matches('img') ? nextLayer : nextLayer.querySelector('img');
      const sources = JSON.parse(next.dataset.cmPrivacyImages);
      const baseLabel = root.querySelector('[data-cm-privacy-current-label]');
      const nextLabel = root.querySelector('[data-cm-privacy-next-label]');
      const setFrame = (image, label, frameIndex) => {
        const frame = sources[frameIndex];
        image.src = frame.src || frame;
        if (frame.alt && image === base) image.alt = frame.alt;
        if (label && frame.label) {
          label.textContent = frame.label;
          label.dataset.tone = frameIndex % 2 ? 'not-this' : 'this';
        }
      };
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0, visible = false, timer, loading;
      const stop = () => { clearInterval(timer); timer = undefined; };
      nextLayer.addEventListener('animationend', () => {
        setFrame(base, baseLabel, index);
        root.classList.remove('is-revealing');
      });
      const start = async () => {
        if (!visible || document.hidden || motion.matches || timer) return;
        loading ||= Promise.all(sources.map(frame => {
          const image = new Image(); image.src = frame.src || frame; return image.decode();
        })).then(() => true).catch(() => false);
        if (!await loading || !visible || document.hidden || motion.matches || timer || !root.isConnected) return;
        timer = setInterval(() => {
          if (!root.isConnected) { stop(); observer.disconnect(); return; }
          index = (index + 1) % sources.length;
          setFrame(next, nextLabel, index); root.classList.add('is-revealing');
        }, 3000);
      };
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting; visible ? start() : stop();
      }, {threshold: .15});
      observer.observe(root);
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
      motion.addEventListener('change', () => {
        if (motion.matches) { stop(); root.classList.remove('is-revealing'); index = 0; setFrame(base, baseLabel, 0); }
        else start();
      });
    });
  }
  initializePrivacyComparisons();
  document.addEventListener('shopify:section:load', event => initializePrivacyComparisons(event.target));
})();
